import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
declare var $:any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

  public loginDetail:any =[];
  public showData:any=false;
  public showData1:any=false;


  constructor(public router: Router, public service: GlobalService) {
    this.loginDetail = JSON.parse(localStorage.getItem('gra_login') || "{}");

  }
  close(){
    $('#CONFIRMPopup').modal('toggle');
  }

  redirect(){
    this.router.navigate(['/dashboard']);
  }

  views(type:any){
    if(type==1){
      if(this.showData){
        this.showData= false;
      } else {
        this.showData=true;
      }
    } else {
      if(this.showData1){
        this.showData1= false;
      } else {
        this.showData1=true;
      }
    }
   
  }
}
